export default "__VITE_ASSET__esDFWGWn__"